export function toPreviewDataUrl(base64?: string | null): string | null {
  if (!base64) return null;
  const raw = base64.trim();
  if (!raw) return null;
  if (raw.startsWith('data:')) return raw;

  let mime = 'image/png';
  if (raw.startsWith('/9j/')) mime = 'image/jpeg';
  else if (raw.startsWith('R0lGOD')) mime = 'image/gif';
  else if (raw.startsWith('UklGR')) mime = 'image/webp';
  else if (raw.startsWith('PHN2Zy') || raw.startsWith('PD94bWw')) mime = 'image/svg+xml';

  return `data:${mime};base64,${raw}`;
}
